import { useState } from 'react';
import SettingIcon from '@/assets/images/Setting.svg';
import styles from './index.module.less';
import MenuIconButton from '../MenuIconButton';
import SettingModal from './SettingModal';
import { RecordFile, RtsError } from '@/types/rtsTypes';
import { isRtsError } from '@/utils/rtsUtils';

interface SettingProps {
  text?: string;
  getRecordList: () => Promise<
    | RtsError
    | {
        video_list: Record<string | number, RecordFile[]>;
      }
  >;
}

export default function (props: SettingProps) {
  const { getRecordList, text } = props;
  const [modalOpen, setModalOpen] = useState(false);

  const [recordList, setRecordList] = useState<RecordFile[]>([]);

  const handleSettingModalOpen = async () => {
    setModalOpen(true);

    const res = await getRecordList();
    if (!isRtsError(res)) {
      const { video_list: videos } = res;

      const recordList = Reflect.ownKeys(videos)
        .map((key) => videos[key as string])
        .flat();
      setRecordList(recordList);
    }
  };

  return (
    <div className={styles.menuButton}>
      <MenuIconButton
        iconClassName={styles.normalIcon}
        onClick={handleSettingModalOpen}
        text={text}
        icon={SettingIcon}
      />

      <SettingModal
        open={modalOpen}
        recordList={recordList}
        onClose={() => {
          setModalOpen(false);
        }}
      />
    </div>
  );
}
